var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#3E4E5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20036 4L7.20036 7.11081C7.20036 7.44437 7.22015 7.77521 7.25973 8.10333C7.29931 8.43145 7.35149 8.76592 7.41626 9.10673H8.54979C8.61456 8.76592 8.66674 8.43145 8.70632 8.10333C8.7459 7.77521 8.7657 7.44437 8.7657 7.11081V4H7.20036ZM8.94922 11.07C8.94922 10.9395 8.92493 10.818 8.87635 10.7056C8.82777 10.5932 8.7612 10.4954 8.67663 10.412C8.59207 10.3286 8.49221 10.2624 8.37706 10.2135C8.26191 10.1645 8.13596 10.14 7.99922 10.14C7.86607 10.14 7.74193 10.1645 7.62678 10.2135C7.51162 10.2624 7.41087 10.3286 7.3245 10.412C7.23814 10.4954 7.17067 10.5932 7.12209 10.7056C7.07351 10.818 7.04922 10.9395 7.04922 11.07C7.04922 11.2005 7.07351 11.3229 7.12209 11.4371C7.17067 11.5513 7.23814 11.6501 7.3245 11.7335C7.41087 11.8169 7.51162 11.8822 7.62678 11.9293C7.74193 11.9764 7.86607 12 7.99922 12C8.13596 12 8.26191 11.9764 8.37706 11.9293C8.49221 11.8822 8.59207 11.8169 8.67663 11.7335C8.7612 11.6501 8.82777 11.5513 8.87635 11.4371C8.92493 11.3229 8.94922 11.2005 8.94922 11.07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.80924ea0.svg";
export { ForwardRef as ReactComponent };